import React, { useState } from "react";
import "../assets/css/assessmentform.css";
import Hero from "./Hero";
import HeroAssessment from "./HeroAssessment";
import { useNavigate } from "react-router-dom";
import { AuthApisUser } from "../api/userapi/userauth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../pages/Admin/Context/AuthContext";
import { setSessionUser, setSessionToken } from "../utils/storageHelper";
import Header from "./Header";
import Footer from "./Footer";

const AssessmentForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({}); // store errors per field
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();

  const Cancel = () => {
    // navigate("http://tools.bee-net.co.uk/");
    window.location.href = "http://tools.bee-net.co.uk/";
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    let fieldErrors = {};

    // Validation
    if (!email) fieldErrors.email = "Email cannot be empty!";
    if (!password) fieldErrors.password = "Password cannot be empty!";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email))
      fieldErrors.email = "Invalid email address!";

    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
      return;
    }

    setErrors({}); // clear errors if all good

    // Real backend call
    try {
      setLoading(true);
      const data = { email, password };
      const response = await AuthApisUser.UserLogin(data);

      if (response.status === 200) {
        const userData = response.data.user;
        const token = response.data.access;

        if (token) {
          setSessionUser(userData);
          setSessionToken(token);
        } else {
          console.warn("No token found in response:", response.data);
        }

        navigate("/user/assessment-landing-page");
        toast.success("Login successful");
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Login failed. Please check your credentials.");
      } else {
        toast.error("Something went wrong. Please try again.");
        console.log("Login error:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <HeroAssessment />
      <div className="login-container1 d-flex justify-content-center min-vh-100">
        <div
          className="container my-5"
          style={{ backgroundColor: "rgb(248,249,250)", border: "none" }}
        >
          <div
            className="row justify-content-center"
            style={{ backgroundColor: "rgb(248,249,250)" }}
          >
            <div className="col-lg-8 col-md-10 col-sm-12">
              <div
                className="p-5  border-0  text-start"
                style={{ backgroundColor: "rgb(248,249,250)" }}
              >
                <h2 className="assessment-title1 mb-4">
                  Cyber Security Management Maturity
                </h2>

                <p
                  className="form-description1 b-5"
                  style={{ backgroundColor: "rgb(248,249,250)" }}
                >
                  Please Enter the email address you used to register for this
                  assessment and
                  <br />
                  the password we emailed to this address.
                </p>

                <form onSubmit={handleLogin}>
                  {/* Email Field */}
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label1">
                      Email
                    </label>
                    <input
                      type="email"
                      className={`form-control1 ${
                        errors.email ? "input-error" : ""
                      }`}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      id="email"
                      style={{ fontSize: "18px" }}
                    />
                    {errors.email && (
                      <small className="error-text">{errors.email}</small>
                    )}
                  </div>

                  {/* Password Field */}
                  <div className="mb-5">
                    <label htmlFor="password" className="form-label1">
                      Password
                    </label>
                    <input
                      type="password"
                      className={`form-control1 ${
                        errors.password ? "input-error" : ""
                      }`}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      id="password"
                      style={{ fontSize: "18px" }}
                    />
                    {errors.password && (
                      <small className="error-text">{errors.password}</small>
                    )}
                  </div>

                  <div className="button-box1">
                    <button
                      type="button"
                      className="btn1 cancel-btn1"
                      onClick={() => Cancel()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn1 login-btn1">
                      Login
                    </button>
                  </div>
                </form>

                <p className="mt-5 description1">
                  If you are unable to find your password or have yet to receive
                  it, please
                  <br />
                  email{" "}
                  <a
                    href="mailto:info@bee-net.co.uk"
                    style={{
                      color: "#7C8C27",
                      textDecoration: "underline !important", // ← works!
                    }}
                  >
                    info@bee-net.co.uk
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AssessmentForm;
